import { Injectable, isDevMode } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AcumaticaService } from "../acumatica/acumatica.service";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { PasswordDialog } from "../common/password-dialog/password-dialog.component";

@Injectable({ providedIn: 'root' })
export class AuthGuard_LoggedIn implements CanActivate {
    constructor(private router: Router, private acumatica: AcumaticaService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return !!this.acumatica.username || this.router.navigate(['/login']);
    }
}

@Injectable({ providedIn: 'root' })
export class AuthGuard_AdminUser implements CanActivate {
    constructor(private dialog: MatDialog, private acumatica: AcumaticaService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return this.acumatica.username == 'NickH' || new Promise<boolean>(resolver =>
            this.dialog.open(PasswordDialog).afterClosed().subscribe(resolver)
        );
    }
}


@Injectable({ providedIn: 'root' })
export class AuthGuard_WMS implements CanActivate {
    constructor(private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return environment.mode == 'wms' || this.router.navigate(['/']);
    }
}

@Injectable({ providedIn: 'root' })
export class AuthGuard_Rep implements CanActivate {
    constructor(private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return environment.mode == 'rep' || this.router.navigate(['/']);
    }
}

@Injectable({ providedIn: 'root' })
export class AuthGuard_DEV implements CanActivate {
    constructor(private router: Router, private acumatica: AcumaticaService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {
        return isDevMode() || this.router.navigate(['/']) || this.acumatica.username?.toUpperCase() == 'NICKH';
    }
}